import script from "./dashbHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./dashbHistory.vue?vue&type=script&setup=true&lang=js"

import "./dashbHistory.vue?vue&type=style&index=0&id=508ecc98&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508ecc98"]])

export default __exports__